package com.dotdrives.repository

import com.dotdrives.client.DonorClient
import com.dotdrives.model.*

interface DonorRepository {
    suspend fun organizations(): Result<List<DonorOrganization>>

    suspend fun page(orgId: String, after: String?): Result<DonorSnapshot>

    suspend fun updates(orgId: String): Result<List<DonorUpdate>>

    suspend fun openUpdate(orgId: String, id: String): Result<Unit>

    suspend fun saveContact(orgId: String, phone: String, address: String): Result<Unit>

    suspend fun attachment(orgId: String, id: String): Result<DocumentDownload>

    suspend fun document(id: String, retry: Boolean): Result<DocumentDownload>

    suspend fun recurring(request: DonorRecurringRequest): Result<DonorRecurringResult>
}

class SupabaseDonorRepository(private val client: DonorClient = DonorClient()) : DonorRepository {
    override suspend fun organizations() = runCatching { client.organizations() }

    override suspend fun page(orgId: String, after: String?) = runCatching {
        client.page(orgId, after)
    }

    override suspend fun updates(orgId: String) = runCatching { client.updates(orgId) }

    override suspend fun openUpdate(orgId: String, id: String) = runCatching {
        client.openUpdate(orgId, id)
    }

    override suspend fun saveContact(orgId: String, phone: String, address: String) = runCatching {
        client.saveContact(orgId, phone, address)
    }

    override suspend fun attachment(orgId: String, id: String) = runCatching {
        client.attachment(orgId, id)
    }

    override suspend fun document(id: String, retry: Boolean) = runCatching {
        client.document(id, retry)
    }

    override suspend fun recurring(request: DonorRecurringRequest) = runCatching {
        client.recurring(request)
    }
}
